import { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { Button, Form, Input } from 'reactstrap';
import { PhoneInput } from 'react-international-phone';
import { errorMsg, successMsg } from '../../cache/vars';
import GooglePlaceAutocompleteInput from '../GooglePlaceAutocomplete/GooglePlaceAutocomplete';
import CardDeclineBtn from '../StagedCard/CardDeclineBtn/CardDeclineBtn';
import { DECLINE_SERVICE, GET_AVAILABLE_FILTERS_FOR_PACKAGE_INFO, GET_FILE_DOWNLOAD_LINK, SAVE_STAGE_ONE_CARD } from '../../queries/vip-workflow';
import { SERVICE_STATE } from '../../utils/constants';
import StagedCardLayout from '../StagedCard/StagedCardLayout/StagedCardLayout';
import CardDetails from '../StagedCard/CardDetails/CardDetails';
import CardGoogleMap from '../StagedCard/CardGoogleMap/CardGoogleMap';
import CardGuaranteed from '../StagedCard/CardGuaranteed/CardGuaranteed';
import CardAction from '../StagedCard/CardAction/CardAction';
import { TicketActions } from '../Modal/TicketActions';
import { TicketsPreviewModal } from '../Modal/TicketsPreviewModal';
import partyIcon from '../../assets/img/icons/cards/party-icon.svg';
import reservationIcon from '../../assets/img/icons/cards/reservation-icon.svg';
import ticketIcon from "../../assets/img/icons/common/ticket-icon.svg";
import carIcon from '../../assets/img/icons/cards/car-icon.svg';
import flagIcon from '../../assets/img/icons/cards/flag-icon.svg';
import preShowIcon from '../../assets/img/icons/cards/pre-show-icon.svg';
import mapIcon from '../../assets/img/icons/cards/map-icon.svg';
import transportingIcon from "../../assets/img/icons/cards/transporting-icon.svg";
import helpIcon from '../../assets/img/icons/cards/help-icon.svg';
import { generateMailtoLink, truncateString, formatPhoneNumber } from '../../utils/services';
import GetHelpModal from '../Modal/GetHelpModal';

import './limoGroupCardNew.scss';


type LimoGroupCardNewProps = {
  cart: any;
  datetime: any | null;
  time: string;
  isMissingInfo: boolean;
  isPublished: boolean;
  isServiceDeclined: boolean;
  serviceDeclined: string;
  packageDetailsId: number;
  setPackageOrderWithDetails: (data: any) => void;
  decryptedInvoiceId: any;
  setMissingInfoCards: any;
  cardDescription: string;
  cardGroup: string;
  cardsWithTickets: Record<string, any>;
  ticketsForCard: Record<string, any>;
};

const LimoGroupCardNew = ({
  cart,
  datetime,
  time,
  isMissingInfo,
  isPublished,
  isServiceDeclined,
  serviceDeclined,
  packageDetailsId,
  setPackageOrderWithDetails,
  decryptedInvoiceId,
  setMissingInfoCards,
  cardDescription,
  cardGroup,
  cardsWithTickets,
  ticketsForCard,
}: LimoGroupCardNewProps) => {
  const client = useApolloClient();
  
  const [file, setFile] = useState<string | undefined>("");
  const [ticket, setTicket] = useState<any | undefined>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [selectedFile, setSelectedFile] = useState<string | undefined>("");
  const [emailLink, setEmailLink] = useState("");

  const [cardState, setCardState] = useState<{ packageDetailsId: number; cartData: any }>({
    packageDetailsId,
    cartData: {},
  });
  const [isSubmitBtnDisabled, setIsSubmitBtnDisabled] = useState(true);

  const [isFieldsValid, setIsFieldsValid] = useState({
    contactName: true,
    contactNumber: true,
    pickUpPlaceName: true,
    dropOffPlaceName: true,
  });
  

  
  const handleDeclineClick = async () => {
    if (window.confirm("Are you sure you want to decline this service?")) {
      const { data } = await client.mutate({
        mutation: DECLINE_SERVICE,
        variables: { packageDetailsId: packageDetailsId },
      });
      if (data?.declineService) {
        setPackageOrderWithDetails((prev: any) => {
          return {
            ...prev,
            orderDetails: prev.orderDetails.map((item: any) => {
              return item.packageDetailsId === packageDetailsId
                ? {
                    ...item,
                    cartDetails: {
                      ...item.cartDetails,
                      cartId: data?.declineService,
                      isServiceDeclined: SERVICE_STATE.DECLINED,
                    },
                  }
                : item;
            }),
          };
        });
        successMsg("Service Declined");
      }
    }
  };
  
  useEffect(() => {
    const requiredFields = ['contactName', 'contactNumber', 'pickUpPlaceName', 'dropOffPlaceName'];

    const isRequiredFieldsEmpty = requiredFields.some((el) => {
      return !cardState.cartData[el];
    }) || cardState.cartData['contactNumber'] === '+' || cardState.cartData['contactNumber'].length <= 6;

    setIsSubmitBtnDisabled(isRequiredFieldsEmpty);
  }, [cardState.cartData]);
  
  useEffect(() => {
    generateMailtoLink(client, window.location.pathname, setEmailLink);
  }, [client]);
  
  const cartJsonData = JSON.parse(cart.cartDetails.cartJsonData);

  const tickets = ticketsForCard?.filter((ticket: any) => ticket.deliveryStatus === "UPLOADED" || ticket.eTicketLink);

  return (
    <StagedCardLayout
      cardIcon={transportingIcon}
      cardTitle={cart?.cartDetails?.cardTitle || "Transportation Services"}
      datetime={datetime}
      time={time}
      isPublished={isPublished}
      isServiceDeclined={isServiceDeclined}
      serviceDeclined={serviceDeclined}
      isMissingInfo={isMissingInfo}
      cardGroup={cardGroup}
    >
      <>
        <GetHelpModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} tag={cardGroup.replaceAll(' ', '')} />
        {isPublished &&
          <>
            <CardDetails
              cardIcon={carIcon}
              cardTitle="Vendor Name"
              cardSubtitle={cartJsonData?.vendorName}
            >
              <div className="transfer-card-content">
                <div className="card-content-column">
                  {cartJsonData?.vendorPhone && 
                    <p style={{ fontSize: '14px', fontWeight: '500', fontFamily: "'Inter', sans-serif" }}>Vendor phone</p>
                  }
                  {cartJsonData?.confirmationNumber && <p style={{ fontSize: '14px', fontWeight: '500', fontFamily: "'Inter', sans-serif" }}>Confirmation number</p>}
                </div>
                <div className="card-content-column">
                  {cartJsonData?.vendorPhone && 
                    <p style={{ fontSize: '14px', fontWeight: '400', fontFamily: "'Inter', sans-serif" }}>
                      {/* <a href="tel:+">{cartJsonData?.vendorPhone.startsWith('+1') ? cartJsonData?.vendorPhone.slice(2).trim() : cartJsonData?.vendorPhone.trim()}</a> */}
                      <a href={`tel:${cartJsonData?.vendorPhone}`}>{formatPhoneNumber(cartJsonData?.vendorPhone)}</a>
                    </p>
                  }
                  {cartJsonData?.confirmationNumber && <p style={{ fontSize: '14px', fontWeight: '400', fontFamily: "'Inter', sans-serif" }}>{cartJsonData?.confirmationNumber}</p>}
                </div>
              </div>
            </CardDetails>
            
            <div className="divider"></div>
          
            <CardDetails
              cardIcon={mapIcon}
              cardTitle="Pick Up At"
              cardSubtitleGoogleLink={{
                name: cartJsonData?.pickUpName === cartJsonData?.pickUpPlaceName ? truncateString(cartJsonData?.pickUpName, 30) : cartJsonData?.pickUpName,
                address: !cartJsonData?.pickUpName ? truncateString(cartJsonData?.pickUpPlaceName, 30) : cartJsonData?.pickUpPlaceName,
                // link: cartJsonData?.pickUpPlaceLink,
                link: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  [cartJsonData?.pickUpName, cartJsonData?.pickUpPlaceName].filter(Boolean).join(' '))}`,
                time: cartJsonData?.date || ''
              }}
            >
              <CardGoogleMap address={cartJsonData?.pickUpPlaceName || cartJsonData?.pickUpAddress} className="pl-4" />
            </CardDetails>
          
            <div className="divider"></div>
            <CardDetails
              cardIcon={preShowIcon}
              cardTitle="Pre Show Hospitality At"
              cardSubtitleGoogleLink={{
                name: cartJsonData?.restaurantName, 
                address: cartJsonData?.restaurantPlaceName, 
                link: cartJsonData?.restaurantPlaceLink, 
                time: cartJsonData?.preShowHospitality || ''
              }}
            >
              <CardGoogleMap address={cartJsonData?.restaurantPlaceName || cartJsonData?.restaurantName} className="pl-4" />
            </CardDetails>
            
            <div className="divider"></div>
            <CardDetails
              cardIcon={partyIcon}
              cardTitle="Event At"
              cardSubtitleGoogleLink={{
                name: cartJsonData?.venue, 
                address: cartJsonData?.venueAddress, 
                link: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  [cartJsonData?.venue, cartJsonData?.venueAddress, cartJsonData?.venueСity].filter(Boolean).join(' '))}`,
                time: cartJsonData?.startTime || ''
              }}
            >
              <CardGoogleMap address={cartJsonData?.venueAddress || cartJsonData?.venue} className="pl-4" />
            </CardDetails>

            
            <div className="divider"></div>
            
            <CardDetails
              cardIcon={mapIcon}
              cardTitle="Drop Off At"
              cardSubtitleGoogleLink={{
                name: cartJsonData?.dropOffPlaceName === cartJsonData?.dropOffName ? truncateString(cartJsonData?.dropOffName, 30) : cartJsonData?.dropOffName,
                address: !cartJsonData?.dropOffName ? truncateString(cartJsonData?.dropOffPlaceName, 30) : cartJsonData?.dropOffPlaceName,
                // link: cartJsonData?.dropOffPlaceLink, 
                link: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  [cartJsonData?.dropOffName, cartJsonData?.dropOffPlaceName].filter(Boolean).join(' '))}`,
                time: cartJsonData?.dropOff || ''
              }}
            >
              <CardGoogleMap address={cartJsonData?.dropOffPlaceName || cartJsonData?.dropOffAddress} className="pl-4" />
            </CardDetails>
            
            {!!tickets.length &&
              <>
                <div className="divider"></div>
                <CardDetails
                  cardIcon={ticketIcon}
                  cardTitle="Access Tickets now"
                  children={
                    <div className="mt-4">
                      {ticketsForCard && ticketsForCard.length ? (
                        ticketsForCard.map((ticket: any, index: number) => (
                          <TicketActions
                            ticket={ticket}
                            setFile={setFile}
                            setIsModalOpened={setIsModalOpened}
                            setTicket={setTicket}
                          />
                        ))
                      ) : (
                        <p>No tickets available</p>
                      )}
                    </div>
                  }
                />
              </>
            }
            
            {cartJsonData?.celebration &&
              <>
                <div className="divider"></div>
                
                <CardDetails
                  cardIcon={partyIcon}
                  cardTitle="Celebration"
                  cardSubtitle={cartJsonData?.celebration}
                />
              </>
            }

            <div className="divider"></div>
          
            {cartJsonData?.notes &&
              <>
                <CardDetails
                  cardIcon={flagIcon}
                  cardTitle="Additional Notes"
                  cardDescription={cartJsonData.notes}
                />
                
                <div className="divider"></div>
              </>
            }

            {cartJsonData?.description &&
              <>
                <CardDetails
                  cardIcon={flagIcon}
                  cardTitle="Description"
                  cardDescription={cartJsonData.description}
                />
                
                <div className="divider"></div>
              </>
            }
            
            <CardAction icon={helpIcon} text="Get help" 
              handleClick={() => {
                setIsModalOpen(true)
              }}
            />
          </>
        }

        {!isPublished && isMissingInfo && (
          <>
            <CardDetails
              isEditable={true}
              cardIcon={reservationIcon}
              cardTitle={cart?.cartDetails?.cardTitle || 'Transportation Services'}
              cardSubtitle="Please provide your contact info"
            >
              <>
                <div className="divider"></div>
                <Form
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const requiredFields = [
                      "contactName",
                      "contactNumber",
                      "pickUpPlaceName",
                      "dropOffPlaceName",
                    ];

                    const isRequiredFieldsEmpty = requiredFields.some((el) => {
                      return !cardState.cartData[el];
                    });

                    if (isRequiredFieldsEmpty) {
                      setIsFieldsValid({
                        contactName: !!cardState.cartData?.contactName,
                        contactNumber: !!cardState.cartData?.contactNumber,
                        pickUpPlaceName: !!cardState.cartData?.pickUpPlaceName,
                        dropOffPlaceName: !!cardState.cartData?.dropOffPlaceName,
                      });

                      errorMsg("Required Fields Should Not Be Empty");

                      return;
                    }

                    const { data } = await client.mutate({
                      mutation: SAVE_STAGE_ONE_CARD,
                      variables: { editCartDetailsInput: cardState },
                    });

                    const filtersData = await client.query({
                      query: GET_AVAILABLE_FILTERS_FOR_PACKAGE_INFO,
                      variables: { invoiceId: decryptedInvoiceId },
                      fetchPolicy: "no-cache",
                    });

                    if (data) {
                      setPackageOrderWithDetails((prev: any) => {
                        return {
                          ...prev,
                          orderDetails: [
                            ...prev.orderDetails.map((cart: any) => {
                              return cart.packageDetailsId === packageDetailsId
                                ? {
                                    ...cart,
                                    cartDetails: {
                                      ...cart.cartDetails,
                                      cardTitle: data?.saveStageOneCard.cardTitle,
                                      cartId: data?.saveStageOneCard.cartId,
                                      cartJsonData: data?.saveStageOneCard.cartJsonData,
                                      isPublished: data?.saveStageOneCard.isPublished,
                                      packageDetailsId: data?.saveStageOneCard.packageDetailsId,
                                    },
                                  }
                                : cart;
                            }),
                          ],
                        };
                      });

                      setMissingInfoCards(
                        filtersData.data?.getAvailableFiltersForPackageInfo.showMissingInfoFor,
                      );

                      successMsg("Saved");
                    }
                  }}
                >
                  <div className="inputs-container">
                    <div className="input-container">
                      <label className={!isFieldsValid.contactName ? "label-invalid" : ""}>
                        Contact Name
                      </label>
                      <div className="input-box">
                        <Input
                          className={!isFieldsValid.contactName ? "input-invalid" : ""}
                          type="text"
                          placeholder="Contact Name"
                          name="contactName"
                          invalid={!isFieldsValid.contactName}
                          onChange={(e) => {
                            setCardState((prev: any) => {
                              return {
                                ...prev,
                                cartData: { ...prev.cartData, [e.target.name]: e.target.value },
                              };
                            });
                          }}
                        />
                        <span></span>
                      </div>
                    </div>
                    <div className="input-container">
                      <label className={!isFieldsValid.contactNumber ? "label-invalid" : ""}>
                        Contact Number
                      </label>
                      <div className="input-box">
                        <PhoneInput
                          dialCodePreviewStyleProps={{style: { zIndex: 2, backgroundColor: 'red' }}}
                          countrySelectorStyleProps={{ buttonStyle: { height: "46px", marginTop: 0 }}}
                          inputStyle={{ borderLeft: 0, height: "46px", marginTop: 0 }}
                          defaultCountry="us"
                          value={cardState?.cartData?.contactNumber || ''}
                          onChange={(value: any) => {
                            if (setCardState) {
                              setCardState((prev) => ({
                                ...prev,
                                cartData: {
                                  ...prev.cartData,
                                  contactNumber: value,
                                },
                              }));
                            }
                          }}
                        />
                      </div>
                    </div>{" "}
                    <div className="input-container">
                      <label className={!isFieldsValid.contactName ? "label-invalid" : ""}>
                        Pick-up Address
                      </label>
                      <div className="input-box">
                        <GooglePlaceAutocompleteInput
                          cardState={cardState}
                          setCardState={setCardState}
                          placeLabel="pickUpName"
                          placeName={"pickUpPlaceName"}
                          placeValueName={"pickUpPlaceValue"}
                          placeLinkName={"pickUpPlaceLink"}
                          placeholder="Enter the address where your vehicle will pick you up to start your VIP event experience."
                          isInvalid={!isFieldsValid.pickUpPlaceName}
                        />
                        <span></span>
                      </div>
                    </div>
                    <div className="input-container">
                      <label className={!isFieldsValid.contactName ? "label-invalid" : ""}>
                        Drop-off Address
                      </label>
                      <div className="input-box">
                        <GooglePlaceAutocompleteInput
                          cardState={cardState}
                          setCardState={setCardState}
                          placeLabel="dropOffName"
                          placeName={"dropOffPlaceName"}
                          placeValueName={"dropOffPlaceValue"}
                          placeLinkName={"dropOffPlaceLink"}
                          placeholder="Enter the address where you'd like to be taken after the event wraps up"
                          isInvalid={!isFieldsValid.dropOffPlaceName}
                        />
                        <span></span>
                      </div>
                    </div>
                    <div className="input-container">
                      <label>Celebration</label>
                      <Input
                        type="text"
                        placeholder="Are you celebrating a special occasion?"
                        name="celebration"
                        onChange={(e) => {
                          setCardState((prev: any) => {
                            return {
                              ...prev,
                              cartData: { ...prev.cartData, [e.target.name]: e.target.value },
                            };
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="actions-container">
                    {!isServiceDeclined && <CardDeclineBtn handleClick={handleDeclineClick} />}
                    <Button disabled={isSubmitBtnDisabled} className="btn-round btn-icon d-flex align-items-center save-btn" type="submit">
                      Save
                    </Button>
                  </div>
                </Form>
              </>
            </CardDetails>
            <div className="divider"></div>
            <CardAction icon={helpIcon} text="Get help" 
              handleClick={() => {
                setIsModalOpen(true)
              }}
            />
          </>
        )}
        
        {!isPublished && !isMissingInfo &&
          <>
            <CardDetails
              isToggleExpanded={false}
              cardIcon={reservationIcon}
              cardTitle={cart?.cartDetails?.cardTitle || 'Transportation Services'}
            >
              <div className="pl-4 mb-4">
                <CardGuaranteed text={isServiceDeclined && serviceDeclined !== 'UNDECLINED' ? "You’ve declined this service." : "Details will be provided as the event approaches."} subtext={isServiceDeclined ? "If you need further assistance please use the Get Help button." : ""} />
                {!isServiceDeclined &&
                  <>
                    <div className="divider"></div>

                    <div className="actions-container">
                      <CardDeclineBtn handleClick={handleDeclineClick} />
                    </div>
                  </>
                }
                <div className="divider"></div> 
                <CardAction icon={helpIcon} text="Get help" 
                  handleClick={() => {
                  setIsModalOpen(true)
                }}
            />
              </div>
            </CardDetails>
          
            {cartJsonData?.notes &&
              <CardDetails
                cardIcon={flagIcon}
                cardTitle="Additional Notes"
                cardDescription={cartJsonData.notes}
              />
            }
          </>
        }
        
        <TicketsPreviewModal
          isModalOpened={isModalOpened}
          setIsModalOpened={setIsModalOpened}
          file={file}
          ticket={ticket}
        />
      </>
    </StagedCardLayout>
  );
};

export default LimoGroupCardNew;
